import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IMessage } from '@/Module/Contact/Model/ApiModel';
import { MessageService } from '@/Module/Contact/Service';

export const messageCreateAction = createAsyncThunk<IMessage, Partial<Omit<IMessage, 'id'>>>(
  'contactUs/createMessage',
  (req, { signal }) => {
    return MessageService.createMessage(req, signal).then(({ data: { data } }) => data);
  },
);
